import { AxiosRequestConfig } from 'axios'
import { TraceHeader } from '~constants/traces'
import { isClient } from '~utils/isClient'

export const getIsomorphicLocalstorage = () => {
    if (isClient()) {
        return window.localStorage
    } else {
        return {
            setItem() {
                return undefined
            },
            getItem() {
                return undefined
            },
        }
    }
}

export const getTraceConfig = (operationId?: string): AxiosRequestConfig => {
    if (!operationId) {
        return {}
    }

    return {
        headers: {
            [TraceHeader.OPERATION_ID]: operationId,
        },
    }
}
